import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers/rootReducer';
import { loadPortfolioState } from './utils/localStorageHelper';
export default function configureStore() {
  return createStore(rootReducer, loadPortfolioState(), applyMiddleware(thunk));
}
